<template>
  <div class="container">
    <content-title :nav="nav"></content-title>

    <!-- 学习卡信息 -->
    <el-card class="info-box" v-if="studyCard.id">
      <div class="flex-row" @click="toDetails" style="cursor: pointer">
        <img :src="studyCard.faceUrl" class="face" />
        <div>
          <div class="bold font-size-16">{{ studyCard.title }}</div>
          <div class="margin-top-10">剩余：{{ studyCard.course_num }}节</div>
        </div>
      </div>

      <div class="address-info" v-if="student.name">
        预约人：{{ student.name }}
      </div>

      <div class="address-info">
        服务地址：{{ studyCard.address || "待定" }}
      </div>

      <el-button
        type="primary"
        size="small"
        v-if="studyCard.editAddress"
        class="update-btn"
      >
        修改服务地址
      </el-button>
    </el-card>

    <!-- 服务教练 -->
    <div class="section-title" v-if="coach.id">服务教练</div>
    <el-card class="coach-box" v-if="coach.id">
      <div class="flex-row coach-info">
        <img :src="coach.head_portrait" class="coach-avatar" />
        <div class="flex-col justify-end coach-detail">
          <div>{{ coach.name }}教练</div>
          <div>{{ coach.teaching_categories }}</div>
        </div>
        <el-button
          type="primary"
          size="small"
          @click="openCoachChangeDialog"
          class="change-coach-btn"
        >
          修改教练
        </el-button>
      </div>
    </el-card>
    <!-- 今日预约 -->
    <div class="section-title">今日预约</div>
    <el-card v-if="todayList.length == 0" class="no-data">
      <div>今日暂无预约，可联系教练或机构安排预约</div>
    </el-card>

    <el-card class="list-box" v-if="todayList.length > 0">
      <div class="appointment-item" v-for="item in todayList" :key="item.id">
        <img
          v-if="item.status == 3"
          src="https://img.curiousmore.com/232919"
          class="handle-pic"
        />
        <div>
          <div class="font-size-14">
            {{ studyCard.title }}
          </div>
          <div class="time-info">
            服务时间：{{ item.start_time.slice(5, 16) }}~{{
              item.end_time.slice(11, 16)
            }}
          </div>
          <div class="time-info" v-if="item.completion_time">
            核销时间：{{ item.completion_time }}
          </div>
        </div>
      </div>
    </el-card>

    <!-- 服务信息 -->
    <div class="section-title">服务信息</div>
    <el-card class="list-box" v-if="appointList.length > 0">
      <div class="appointment-item" v-for="item in appointList" :key="item.id">
        <img
          v-if="item.status == 3"
          src="https://img.curiousmore.com/232919"
          class="handle-pic"
        />
        <div>
          <div class="font-size-14">
            {{ studyCard.title }}
          </div>
          <div class="time-info">
            服务时间：{{ item.start_time.slice(5, 16) }}~{{
              item.end_time.slice(11, 16)
            }}
          </div>
          <div class="time-info" v-if="item.completion_time">
            核销时间：{{ item.completion_time }}
          </div>
        </div>
      </div>
    </el-card>

    <el-card v-if="appointList.length == 0" class="no-data">
      <div>暂无预约，可联系教练或机构安排预约</div>
    </el-card>


    <!-- 修改教练弹窗 -->
    <el-dialog
      title="修改上课教练"
      :visible.sync="coachDialogVisible"
      width="600px"
    >
      <el-form label-width="100px">
        <el-form-item label="当前教练">
          <div class="current-coach-info">
            <img :src="coach.head_portrait" class="small-avatar" />
            <span>{{ coach.name }}教练</span>
          </div>
        </el-form-item>
        <el-form-item label="选择新教练" required>
          <coach-select
            :coachid.sync="newCoachId"
            placeholder="请输入教练姓名或电话搜索"
            @change="handleCoachSelect"
          ></coach-select>
        </el-form-item>
        <el-form-item label="新教练信息" v-if="selectedNewCoach">
          <div class="new-coach-info">
            <img :src="selectedNewCoach.head_portrait" class="small-avatar" />
            <div>
              <div>{{ selectedNewCoach.real_name }}教练</div>
              <div class="coach-city">{{ selectedNewCoach.city }}</div>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="coachDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitCoachChange"
          :disabled="!newCoachId"
        >
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import coachSelect from "@/components/select/coachSelect.vue";

export default {
  name: "CardStudyCard",
  components: {
    coachSelect,
  },
  data() {
    return {
      nav: {
        firstNav: "学习卡管理",
        secondNav: "学习卡详情",
      },
      id: "",
      studyCard: {},
      student: {},
      appointList: [],
      todayList: [],
      coach: {},
      addressDialogVisible: false,
      coachDialogVisible: false,
      newCoachId: "",
      selectedNewCoach: null,
    };
  },
  created() {
    this.id = this.$route.query.id;
    if (this.id) {
      this.getData();
      this.getCourse();
    }
  },
  methods: {
    submitAddress() {
      if (this.studyCard.address == this.address.address) {
        this.studyCard.editAddress = false;
        this.$message.success("修改成功");
        this.addressDialogVisible = false;
        return;
      }
      this.$http
        .request({
          url: "/user/userStudyCard/userUpdateAddress",
          data: {
            id: this.id,
            address_id: this.address.id,
          },
          method: "post",
        })
        .then((res) => {
          this.studyCard.editAddress = false;
          this.studyCard.address = this.address.address;
          this.clearAddress();
          this.$message.success("修改成功");
          this.addressDialogVisible = false;
        })
        .catch(() => {
          this.$message.error("修改失败");
        });
    },
    openAddressPop() {
      this.addressDialogVisible = true;
    },
    clearAddress() {
      this.$store.commit("setAddress", {});
    },
    toChangeAddress() {
      // PC端可以打开一个新窗口或使用弹窗选择地址
      this.$router.push({
        path: "/address/changeAddress",
        query: { from: "studyCard" },
      });
    },
    toCoachDetails() {
      this.$router.push({
        path: "/coach/details",
        query: { id: this.coach.id },
      });
    },
    toDetails() {
      if (this.studyCard.type == "need") {
        this.$router.push({
          path: "/coach/needCourse/needDetails",
          query: { id: this.studyCard.studycard_id },
        });
      } else if (this.studyCard.type == "venue") {
        this.$router.push({
          path: "/work/venue/serviceDetails",
          query: { id: this.studyCard.studycard_id },
        });
      } else if (this.studyCard.type == "coach_service") {
        this.$router.push({
          path: "/club/coachService/serviceDetails",
          query: { id: this.studyCard.studycard_id },
        });
      } else {
        this.$router.push({
          path: "/work/classChannel/classChannel",
          query: { id: this.studyCard.studycard_id },
        });
      }
    },
    // 服务信息
    getCourse() {
      this.$get("/user/userAppointment/queryListPage", {
        study_card_id: this.id,
      })
        .then((res) => {
          let list = res.data.data;
          let today = new Date().Format("yyyy-MM-dd");
          let today_course = [];
          let other_course = [];
          list.forEach((item) => {
            if (today == item.start_time.split(" ")[0]) {
              today_course.push(item);
            } else {
              other_course.push(item);
            }
          });
          this.appointList = other_course;
          this.todayList = today_course.sort((a, b) => {
            return a.id - b.id;
          });
        })
        .catch(() => {
          this.$message.error("获取预约列表失败");
        });
    },
    // 学习卡数据
    getData() {
      this.$get("/user/userStudyCard/findById", {
        id: this.id,
      })
        .then((res) => {
          this.studyCard = res.data.data;

          if (this.studyCard.map.need) {
            let need = this.studyCard.map.need || {};
            if (!this.studyCard.address) {
              this.studyCard.latitude = need.latitude;
              this.studyCard.longitude = need.longitude;
              this.studyCard.address = need.address;
            }
            if (need.service_type == 2) {
              this.studyCard.editAddress = true;
            }
            this.studyCard.faceUrl = need.face_url;
          } else {
            let course = this.studyCard.map.course || {};
            if (!this.studyCard.address) {
              this.studyCard.latitude = course.latitude;
              this.studyCard.longitude = course.longitude;
              this.studyCard.address = course.venues_addr;
            }
            if (course.teach_type == 2) {
              this.studyCard.editAddress = true;
            }
            this.studyCard.faceUrl = course.face_url;
          }

          this.student = this.studyCard.map.student || {};
          this.coach = this.studyCard.map.coach || {};
        })
        .catch(() => {
          this.$message.error("获取学习卡信息失败");
        });
    },
    // 打开修改教练弹窗
    openCoachChangeDialog() {
      this.newCoachId = "";
      this.selectedNewCoach = null;
      this.coachDialogVisible = true;
    },
    // 处理教练选择
    handleCoachSelect(coach) {
      this.selectedNewCoach = coach;
    },
    // 提交修改教练
    submitCoachChange() {
      if (!this.newCoachId) {
        this.$message.warning("请选择新教练");
        return;
      }

      if (this.newCoachId == this.coach.id) {
        this.$message.warning("新教练与当前教练相同");
        return;
      }

      this.$confirm(
        `确认将教练修改为：${this.selectedNewCoach.real_name}？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.$post("/user/userStudyCard/updateCoach", {
            id: this.id,
            coach_id: this.newCoachId,
          })
            .then((res) => {
              this.$message.success("修改教练成功");
              this.coachDialogVisible = false;
              // 重新获取学习卡数据
              this.getData();
            })
            .catch(() => {
              this.$message.error("修改教练失败");
            });
        })
        .catch(() => {
          // 用户取消操作
        });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: calc(100vh - 60px);
}

.info-box {
  margin-bottom: 20px;

  .face {
    width: 100px;
    height: 100px;
    margin-right: 15px;
    border-radius: 8px;
    object-fit: cover;
  }

  .address-info {
    margin-top: 10px;
    font-size: 14px;
    color: #606266;
  }

  .update-btn {
    margin-top: 15px;
  }

  .address-wrap {
    padding: 10px 15px;
    background-color: #f5f7fa;
    font-size: 14px;
    margin-top: 10px;
    border-radius: 4px;
    cursor: pointer;

    &:hover {
      background-color: #e4e7ed;
    }
  }

  .submit-btn {
    margin-top: 15px;
  }
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  margin: 20px 0 10px 0;
  padding-left: 10px;
  color: #303133;

  &::before {
    content: "";
    display: inline-block;
    width: 4px;
    height: 16px;
    background-color: #409eff;
    margin-right: 8px;
    vertical-align: middle;
  }
}

.coach-box {
  .coach-info {
    position: relative;
  }

  .coach-avatar {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    margin-right: 15px;
    object-fit: cover;
  }

  .coach-detail {
    flex: 1;
  }

  .change-coach-btn {
    margin-left: auto;
  }
}

.list-box {
  margin-top: 10px;

  .appointment-item {
    padding: 15px 0;
    border-bottom: 1px solid #ebeef5;
    position: relative;

    &:last-child {
      border-bottom: none;
    }

    .handle-pic {
      position: absolute;
      top: 15px;
      right: 15px;
      width: 80px;
      height: 80px;
    }
  }
}

.time-info {
  color: #909399;
  font-size: 14px;
  margin-top: 8px;
}

.no-data {
  text-align: center;
  font-size: 14px;
  color: #909399;
  padding: 30px;
  margin-top: 10px;
}

.flex-row {
  display: flex;
  align-items: center;
}

.flex-col {
  display: flex;
  flex-direction: column;
}

.justify-end {
  justify-content: flex-end;
}

.bold {
  font-weight: bold;
}

.font-size-16 {
  font-size: 16px;
}

.font-size-14 {
  font-size: 14px;
}

.margin-top-10 {
  margin-top: 10px;
}

.current-coach-info,
.new-coach-info {
  display: flex;
  align-items: center;

  .small-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 10px;
    object-fit: cover;
  }
}

.new-coach-info {
  .coach-city {
    font-size: 12px;
    color: #909399;
    margin-top: 4px;
  }
}
</style>
